import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";
import { userStepStatusEvent } from "src/types";

export default function useUserStepStatusEvent() {
  const [bookingStatusName, setBookingStatusName] = useState<userStepStatusEvent | null>(null);
  const [eventApplication] = useRecoilState(recoilStates.eventApplication);
  const [init] = useRecoilState(recoilStates.init);
  useEffect(() => {
    (() => {
      if (!init?.isInit) {
        return;
      }

      if (
        eventApplication?.event_booking_rel_club?.every((r) => {
          return [2].includes(r.status_id || 0);
        })
        // 모두 거절 상태
      ) {
        setBookingStatusName("rejectedAllProposal");
        return;
      }
      if (
        !eventApplication ||
        eventApplication?.event_booking_rel_club?.every((r) => {
          return [2, 4, 6, 7].includes(r.status_id || 0);
        })
        // 부킹이 없거나 모두 거절/취소/만료 상태
      ) {
        setBookingStatusName("noBooking");
        return;
      }

      if (
        eventApplication?.event_booking_rel_club?.every((r) => {
          return [1, 2].includes(r.status_id || 0);
        })
        // 모두신청
      ) {
        setBookingStatusName("waitingProposal");
        return;
      }

      if (
        eventApplication?.event_booking_rel_club?.some((r) => {
          return [3].includes(r.status_id || 0);
        })
        // 한개 이상의 조건제안 상태
      ) {
        setBookingStatusName("hasProposal");
        return;
      }
      if (
        eventApplication?.event_booking_rel_club?.some((r) => {
          return [5].includes(r.status_id || 0);
        })
        // 한개 이상의 조건수락 상태(부킹 성공상태)
      ) {
        setBookingStatusName("hasBooking");
        return;
      }
    })();
  }, [init, eventApplication]);

  return bookingStatusName;
}
